import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

import { updateNumberOfPanelsOnWebJointSegment } from '../../../../store/actions/profileActions';
import { getInsertingOrRewebbingProfile } from '../../../../store/selectors/profileSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { calculateNumberOfPanels } from '../../../interface/subpanels/insertions/component/profile-creator/WebJointSegmentEditor';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';

interface Props {
  readonly guid: string;
}

export function WebJointSegmentMenu({ guid }: Props) {
  const dispatch = useAppDispatch();

  const profile = useAppSelector(getInsertingOrRewebbingProfile);
  const profileLineAndWebJointSegment = profile.profileLines
    .flatMap((profileLine) => profileLine.webJointSegments.map((webJointSegment) => ({ profileLine, webJointSegment })))
    .find(({ webJointSegment }) => webJointSegment.guid === guid);
  if (!profileLineAndWebJointSegment) {
    console.error(`Could not find web joint segment: ${guid}`);
    return null;
  }

  const { profileLine, webJointSegment } = profileLineAndWebJointSegment;
  const numberOfPanels = calculateNumberOfPanels(profile, profileLine, webJointSegment);

  return (
    <SceneMenuContent>
      <SceneMenuItem
        text="Add Panel"
        icon={<AddIcon />}
        disabled={numberOfPanels == null}
        onClick={() => {
          if (numberOfPanels == null) return;
          dispatch(updateNumberOfPanelsOnWebJointSegment(webJointSegment, numberOfPanels + 1));
        }}
      />
      <SceneMenuItem
        text="Remove Panel"
        icon={<RemoveIcon />}
        disabled={numberOfPanels == null || numberOfPanels <= 1}
        onClick={() => {
          if (numberOfPanels == null || numberOfPanels <= 1) return;
          dispatch(updateNumberOfPanelsOnWebJointSegment(webJointSegment, numberOfPanels - 1));
        }}
      />
      <SceneMenuItem
        text="Reset Panels"
        icon={<RestartAltIcon />}
        disabled={numberOfPanels == null || webJointSegment.numberOfFloatingJoints == null}
        onClick={() => {
          if (numberOfPanels == null || webJointSegment.numberOfFloatingJoints == null) return;
          dispatch(updateNumberOfPanelsOnWebJointSegment(webJointSegment, null));
        }}
      />
    </SceneMenuContent>
  );
}
